/**
 * Created by Administrator on 2018/2/28.
 */
const state = {
  pathKey: 'projectMap',
  pathName: ''
};
const mutations = {
  changePath(state, path) {
    state.pathKey = path.enPath;
    state.pathName = path.cnPath;
    localStorage.setItem('changePath', JSON.stringify(path));
  }
};
const actions = {};
const getters = {};

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/managers/vuex/modules/navigation.js